import * as React from "react";
const SvgFiRrDuration = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-duration_svg__a)">
      <path
        fill="#062147"
        d="M8.022 15.811c-.12.63.292 1.214.476 1.436.401.486.91.753 1.434.753h4.136c.835 0 1.3-.349 1.543-.642.332-.403.462-.965.352-1.545-.258-1.358-1.078-2.637-2.421-3.806 1.342-1.168 2.162-2.447 2.422-3.807.109-.579-.02-1.141-.354-1.544-.242-.293-.707-.642-1.542-.642H9.932c-.524 0-1.033.268-1.434.753-.184.222-.597.806-.476 1.435.261 1.359 1.085 2.638 2.435 3.805-1.35 1.167-2.175 2.446-2.435 3.804m2.015-7.766.026-.031h3.893c-.22.865-.989 1.862-1.957 2.688-.962-.814-1.735-1.803-1.963-2.657m1.961 5.268c.959.816 1.725 1.805 1.953 2.688h-3.888l-.027-.031c.229-.853 1.002-1.842 1.963-2.657M9.029 1.359A1 1 0 0 1 9.832.195C10.543.066 11.272 0 12.001 0a1 1 0 0 1 0 2c-.607 0-1.216.055-1.81.163a1 1 0 0 1-1.163-.804M1.574 15.658q-.124.03-.244.03a1 1 0 0 1-.969-.757 12 12 0 0 1-.335-2.152 1 1 0 0 1 1.996-.128c.04.605.133 1.208.28 1.794a1 1 0 0 1-.727 1.213M3.942 4.446a1 1 0 0 1 .082-1.412 12 12 0 0 1 1.751-1.295 1.001 1.001 0 0 1 1.04 1.709 10 10 0 0 0-1.46 1.08 1 1 0 0 1-1.413-.082M20.921 4c3.146 3.52 4.154 8.764 1.739 13.473-1.662 3.238-4.742 5.615-8.316 6.302-4.934.949-9.754-1.166-12.404-5.229a1 1 0 0 1 1.676-1.092c2.36 3.619 6.786 5.384 11.183 4.16a9.74 9.74 0 0 0 5.468-3.997c2.896-4.372 1.95-9.566-1.267-12.74V8a1 1 0 1 1-2 0V4a2 2 0 0 1 2-2h4a1 1 0 1 1 0 2zM.527 8.47c.213-.694.492-1.372.83-2.016a1 1 0 1 1 1.771.926 10 10 0 0 0-.689 1.678A1.001 1.001 0 1 1 .527 8.47"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-duration_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDuration;
